# GraphQL query to get all the emails for a given stage

#import "../fragments/email-automation.graphql"

query GetEmailAutomation($emailAutomationId: ID!) {
    emailAutomation(id: $emailAutomationId) {
        ...EmailAutomation
    }
}
